package app.nestbridge.feature.careteam.ui

import app.nestbridge.feature.careteam.screen.CreateCareTeamScreen
import app.nestbridge.feature.careteam.screen.CreateCareTeamState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class CreateCareTeamUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is CreateCareTeamScreen -> ui<CreateCareTeamState> { state, modifier -> CreateCareTeamUi(state = state, modifier = modifier) }
    else -> null
  }
}
